(function () {
  'use strict';
  if (window.__bolodooDeliveryTimeline) return;
  window.__bolodooDeliveryTimeline = true;

  const hosts = '.bnd-delivery, .fgd__delivery, .mss__delivery, .mws__delivery';
  const controllers = new Map();
  function enhance(host) {
    if (controllers.has(host) || host.closest('.product__popup')) return;
    const prefix = ['bnd', 'fgd', 'mss', 'mws'].find(value => host.querySelector(`[data-${value}-tailoring]`));
    if (!prefix) return;
    let source = host.querySelector('.bolodoo-delivery-details');
    if (!source) {
      source = document.createElement('details');
      source.className = 'bolodoo-delivery-details';
      const summary = document.createElement('summary');
      summary.className = 'bolodoo-delivery-summary';
      summary.innerHTML = '<span class="bolodoo-delivery-more">Delivery details</span>';
      const content = document.createElement('div');
      content.className = 'bolodoo-delivery-content';
      content.append(...host.childNodes);
      source.append(summary, content);
      host.append(source);
    }
    const timeline = document.createElement('section');
    timeline.className = 'bdt';
    timeline.setAttribute('aria-label', 'Delivery estimate');
    timeline.innerHTML = `
      <div class="bdt__head"><div class="bdt__destination">Ship to <span data-bdt-country></span></div><div class="bdt__methods" role="group" aria-label="Shipping method"><button type="button" data-bdt-method="standard" aria-pressed="true">Standard</button><button type="button" data-bdt-method="expedited" aria-pressed="false">Expedited</button></div></div>
      <div class="bdt__timeline">
        <div class="bdt__item"><span class="bdt__icon" aria-hidden="true">&#xe652;</span><div class="bdt__time-wrap"><div class="bdt__label">Tailoring Time</div><div class="bdt__duration"><span class="bdt__value" data-bdt-processing></span><abbr data-bdt-processing-unit></abbr></div></div></div>
        <div class="bdt__item"><span class="bdt__icon" aria-hidden="true">&#xe653;</span><div class="bdt__time-wrap"><div class="bdt__label">Shipping Time</div><div class="bdt__duration"><span class="bdt__value" data-bdt-shipping></span><abbr data-bdt-shipping-unit></abbr></div></div></div>
        <div class="bdt__item bdt__delivery"><span class="bdt__icon" aria-hidden="true">&#xe665;</span><div class="bdt__time-wrap bdt__desktop"><div class="bdt__label">Delivery Time</div><div class="bdt__duration"><span class="bdt__value" data-bdt-arrival-line></span></div></div></div>
      </div>
      <div class="bdt__description bdt__desktop"></div>
      <div class="bdt__order-today">Order today, get it <span class="bdt__value" data-bdt-arrival></span></div>`;
    timeline.querySelector('.bdt__description').textContent = source.querySelector('.bnd-description, .fgd__delivery-description, .mss__delivery-description, .mws__delivery-description')?.textContent.trim() || '';
    const methods = timeline.querySelector('.bdt__methods');
    host.prepend(timeline);
    host.classList.add('bdt-host');
    source.open = false;
    source.hidden = true;
    let method = 'standard';
    const read = key => source.querySelector(`[data-${prefix}-${key}]`)?.textContent.trim() || '';
    const show = (key, value) => {
      const node = timeline.querySelector(`[data-bdt-${key}]`);
      if (node.textContent !== value) node.textContent = value;
    };
    const duration = (key, value) => {
      const text = value.replace(/^Shipping Time:\s*/i, '');
      const match = text.match(/^(\d+\s*-\s*\d+)\s+(Business Days|Days)$/i);
      show(key, match ? match[1].replace(/\s*-\s*/, '-') : text);
      show(`${key}-unit`, match ? 'Days' : '');
      const unit = timeline.querySelector(`[data-bdt-${key}-unit]`);
      unit.setAttribute('title', match ? match[2] : '');
      unit.setAttribute('aria-label', match ? match[2] : '');
      unit.parentElement.setAttribute('aria-label', text);
    };
    const render = () => {
      const destination = read('country') || source.querySelector('[class$="destination"] strong')?.textContent.trim() || '';
      show('country', destination);
      duration('processing', read('tailoring'));
      duration('shipping', read(`${method}-time`));
      const date = read(`${method}-date`).replace(/\.\s+/g, '.');
      show('arrival', date);
      show('arrival-line', date);
      methods.querySelectorAll('[data-bdt-method]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bdtMethod === method)));
    };
    methods.addEventListener('click', event => {
      const button = event.target.closest('[data-bdt-method]');
      if (!button) return;
      method = button.dataset.bdtMethod;
      render();
    });
    // Observe the original calculation outputs; never calculate a second delivery estimate.
    const observer = new MutationObserver(render);
    observer.observe(source, { subtree: true, childList: true, characterData: true });
    controllers.set(host, observer);
    render();
  }
  function init() {
    for (const [host, observer] of controllers) {
      if (!host.isConnected) { observer.disconnect(); controllers.delete(host); }
    }
    document.querySelectorAll(hosts).forEach(enhance);
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
